export default "__VITE_ASSET__7e7d839b__"